import { Box, Typography } from '@mui/material'
import { IDocument } from 'hooks/useHelpDocument/useHelpDocument'
import Markdown from 'markdown-to-jsx'
import RelateDocuments from './RelateDocuments'

const ResponsiveImage = ({ alt, src, title }: any) => (
    <img
        src={src}
        alt={alt}
        title={title}
        style={{
            maxWidth: '65vw',
            height: 'auto',
            display: 'block',
            margin: '0 auto',
        }}
    />
)

export default function DocumentDisplay({
    docs,
    displayDoc,
}: {
    displayDoc: IDocument | undefined
    docs: IDocument[]
}) {
    if (!displayDoc?.content)
        return (
            <Typography align="center" padding={10}>
                Not found Content
            </Typography>
        )
    return (
        <Box>
            <Markdown
                children={displayDoc.content}
                options={{
                    overrides: {
                        img: {
                            component: ResponsiveImage,
                        },
                    },
                    forceBlock: true,
                }}
            />
            {(displayDoc?.relatedDocs?.length ?? 0) > 0 && (
                <RelateDocuments
                    docs={docs}
                    relateDocumentTitles={displayDoc.relatedDocs}
                />
            )}
        </Box>
    )
}
